<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  mounted() {
    if (process.env.VUE_APP_HEADER_COLOR) {
      document.documentElement.style.setProperty('--header-bg', process.env.VUE_APP_HEADER_COLOR)
    }
  },
}
</script>
